<template>
  <vs-prompt
    title="航海日を選ぶ"
    accept-text="決定"
    cancel-text="キャンセル"
    :is-valid="validCalendarPicker"
    :active.sync="calendarActive"
    @accept="calendarOnAccept"
    @cancel="calendarOnCancel"
    @close="calendarOnClose"
  >
    <div class="calendar" style="padding-left: 20px">
      <div class="vx-row">
        <div class="vx-col w-full">
          <label class="vs-input--label">航海日</label>
          <flat-pickr
            v-model="historyDate"
            placeholder="航海日を選択してください"
            :config.sync="configDayPicker"
            style="width: 95%;"
          />
        </div>
      </div>
      <div class="vx-row pt-6 pb-6">
        <div class="vx-col w-full">
          <label class="vs-input--label">再生開始時間</label>
          <flat-pickr
            v-model="historyStartTime"
            placeholder="再生開始時間を選択してください"
            :config.sync="configTimePicker"
            style="width: 95%;"
          />
        </div>
        <div class="vx-col w-full">
          <label v-show="!is10minUnit" class="vs-input--label danger"
            >30分単位で入力してください</label
          >
        </div>
      </div>
    </div>
  </vs-prompt>
</template>

<script>
import { DateUtil } from "@/utils";

// components
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { Japanese } from "flatpickr/dist/l10n/ja.js";

export default {
  components: {
    flatPickr
  },
  props: {},
  data() {
    return {
      calendarActive: false,
      from: null,
      to: null,
      dayDiff: null,
      aug: null,
      params: null,
      paramsForNext: null,
      historyDate: null,
      dayList: [],
      configDayPicker: {
        dateFormat: "Y-m-d",
        time_24hr: true,
        minDate: "",
        maxDate: "",
        locale: Japanese
      },
      historyStartTime: null,
      configTimePicker: {
        enableTime: true,
        noCalendar: true,
        minuteIncrement: 10,
        time_24hr: true,
        dateFormat: "H:i",
        minTime: "00:00",
        maxTime: "23:50",
        locale: Japanese
      },
      vessel: null
    };
  },
  watch: {
    historyDate() {
      if (this.historyStartTime) {
        let diff = DateUtil.diff(this.from, this.historyDate, "day");
        if (diff === 0) {
          let startTimeLocal = DateUtil.toMomentObj(
            this.params.startUtc
          ).format("HH:mm:ss");
          let minTime = DateUtil.rounding10min(startTimeLocal);
          this.configTimePicker.minTime = minTime;
          this.configTimePicker.maxTime = "23:50";
          this.historyStartTime = minTime;
        } else if (diff === this.dayDiff) {
          let endTimeLocal = DateUtil.toMomentObj(this.params.endUtc).format(
            "HH:mm:ss"
          );
          let maxTime = DateUtil.rounding10min(endTimeLocal);
          this.configTimePicker.minTime = "00:00";
          this.configTimePicker.maxTime = maxTime;
          this.historyStartTime = "00:00";
        } else {
          this.configTimePicker.minTime = "00:00";
          this.configTimePicker.maxTime = "23:50";
          this.historyStartTime = "00:00";
        }
      }
    }
  },
  computed: {
    validCalendarPicker() {
      let isRequired =
        this.historyDay !== null && this.historyStartTime !== null;
      return isRequired && this.check10min();
    },
    is30minUnit() {
      return this.check30min();
    },
    is10minUnit() {
      return this.check10min();
    }
  },
  methods: {
    show(params) {
      this.dayList = [];
      this.historyStartTime = null;
      this.params = params;
      this.vessel = params.vessel;
      this.configPicker();
      this.crateDayList();
      this.calendarActive = true;
    },

    configPicker() {
      this.from = DateUtil.toMomentObj(this.params.startUtc).format(
        "YYYY-MM-DD"
      );
      this.to = DateUtil.formatter(this.params.endUtc).format("YYYY-MM-DD");
      this.configDayPicker.minDate = this.from;
      this.configDayPicker.maxDate = this.to;
      this.historyDate = this.from;
      let startTimeLocal = DateUtil.toMomentObj(this.params.startUtc).format(
        "HH:mm:ss"
      );
      let minTime = DateUtil.rounding10min(startTimeLocal);
      this.configTimePicker.minTime = minTime;
      this.historyStartTime = minTime;
    },
    crateDayList() {
      this.dayDiff = DateUtil.diff(this.from, this.to, "day");
      for (let i = 0; i < this.dayDiff + 1; i++) {
        this.dayList.push(
          DateUtil.addTime(this.params.startUtc, i, "day").format("YYYY-MM-DD")
        );
      }
    },

    check30min() {
      if (!this.historyStartTime) return true;
      let min = this.historyStartTime.substr(-2);
      return min === "00" || min === "30";
    },

    check10min() {
      if (!this.historyStartTime) return true;
      let min = this.historyStartTime.substr(-1);
      return min === "0";
    },

    rounding30min(target) {
      let res;
      let mm = Number(target.split(":")[1]);
      if (mm >= 30) {
        res = `${target.split(":")[0]}:30:00`;
      } else {
        res = `${target.split(":")[0]}:00:00`;
      }
      return res;
    },

    rounding30minForEnd(target) {
      let res;
      let h = Number(target.split(":")[0]);
      let mm = Number(target.split(":")[1]);
      if (mm <= 0) {
        let hh = ("00" + h).slice(-2);
        res = `${hh}:00:00`;
      } else if (mm <= 30) {
        let hh = ("00" + h).slice(-2);
        res = `${hh}:30:00`;
      } else {
        let hh = ("00" + (h + 1)).slice(-2);
        res = `${hh}:00:00`;
      }
      return res;
    },

    calendarOnAccept() {
      let diff = DateUtil.diff(this.from, this.historyDate, "day");
      let params;
      if (diff === 0) {
        let timeLabelStart = DateUtil.toMomentObj(this.params.startUtc).format(
          "YYYY年MM月DD日 HH:mm:ss"
        );
        let timeLabelEnd = "23:59:59";
        let targetDayLocal = this.dayList[diff];
        let startTimeLocal = DateUtil.toMomentObj(this.params.startUtc).format(
          "HH:mm:ss"
        );
        let startLocal = `${targetDayLocal}T${DateUtil.rounding10min(
          startTimeLocal
        )}`;
        let endLocal = `${targetDayLocal}T24:00:00`;
        let startTimeLocalByInput = DateUtil.rounding10min(
          `${this.historyStartTime}:00`
        );
        let startLocalByInput = `${targetDayLocal}T${startTimeLocalByInput}`;
        let startUtc = DateUtil.toMomentObj(startLocalByInput)
          .utc()
          .format("YYYY-MM-DDTHH:mm:ss");
        let endUtc = DateUtil.addTime(startUtc, 10, "m").format(
          "YYYY-MM-DDTHH:mm:ss"
        );
        params = {
          vessel: this.vessel,
          startUtc: `${startUtc}.000Z`,
          endUtc: `${endUtc}.000Z`,
          startLocal: `${startLocal}.000Z`,
          endLocal: `${endLocal}.000Z`,
          timeLabel: `${timeLabelStart} - ${timeLabelEnd}`,
          fromPicker: true
        };
      } else if (diff === this.dayDiff) {
        let timeLabelStart = `${DateUtil.toMomentObj(this.params.startUtc).format("YYYY年MM月DD日")} 00:00:00`
        let timeLabelEnd = DateUtil.toMomentObj(this.params.endUtc).format("HH:mm:ss")
        let targetDayLocal = this.dayList[diff];
        let startLocal = `${targetDayLocal}T00:00:00`;
        let endTimeLocal = DateUtil.toMomentObj(this.params.endUtc).format(
          "HH:mm:ss"
        );
        let endLocal = `${targetDayLocal}T${DateUtil.rounding10min(
          endTimeLocal
        )}`;

        let startTimeLocalByInput =DateUtil.rounding10min(
          `${this.historyStartTime}:00`
        );
        let startLocalByInput = `${targetDayLocal}T${startTimeLocalByInput}`;
        let startUtc = DateUtil.toMomentObj(startLocalByInput)
          .utc()
          .format("YYYY-MM-DDTHH:mm:ss");
        let endUtc = DateUtil.addTime(startUtc, 10, "m").format(
          "YYYY-MM-DDTHH:mm:ss"
        );
        params = {
          vessel: this.vessel,
          startUtc: `${startUtc}.000Z`,
          endUtc: `${endUtc}.000Z`,
          startLocal: `${startLocal}.000Z`,
          endLocal: `${endLocal}.000Z`,
          timeLabel: `${timeLabelStart} - ${timeLabelEnd}`,
          fromPicker: true
        };
      } else {
        let timeLabelStart = `${DateUtil.toMomentObj(this.params.startUtc).format("YYYY年MM月DD日")} 00:00:00`
        let timeLabelEnd = "23:59:59";

        let targetDayLocal = this.dayList[diff];
        let startLocal = `${targetDayLocal}T00:00:00`;
        let endLocal = `${targetDayLocal}T24:00:00`;

        let startTimeLocalByInput = DateUtil.rounding10min(
          `${this.historyStartTime}:00`
        );
        let startLocalByInput = `${targetDayLocal}T${startTimeLocalByInput}`;

        let startUtc = DateUtil.toMomentObj(startLocalByInput)
          .utc()
          .format("YYYY-MM-DDTHH:mm:ss");
        let endUtc = DateUtil.addTime(startUtc, 10, "m").format(
          "YYYY-MM-DDTHH:mm:ss"
        );
        params = {
          vessel: this.vessel,
          startUtc: `${startUtc}.000Z`,
          endUtc: `${endUtc}.000Z`,
          startLocal: `${startLocal}.000Z`,
          endLocal: `${endLocal}.000Z`,
          timeLabel: `${timeLabelStart} - ${timeLabelEnd}`,
          fromPicker: true
        };
      }
      this.$router.push({
        name: "voyage-history-player",
        params: params
      });
    },
    calendarOnCancel() {},
    calendarOnClose() {}
  }
};
</script>

<style lang="scss"></style>
